import type { LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

export type SocialLink = {
  name: 'YouTube' | 'Facebook' | 'Instagram'
  url: string
  ariaLabel: string
  Icon: LucideIcon
}

const Youtube = createLucideIcon('Youtube', [
  ['path', { d: 'M2.5 8.5c.2-1.5 1.2-2.6 2.7-2.8C7 5.5 9.5 5.5 12 5.5s5 0 6.8.2c1.5.2 2.5 1.3 2.7 2.8.2 1 .2 2.2.2 3.5s0 2.5-.2 3.5c-.2 1.5-1.2 2.6-2.7 2.8-1.8.2-4.3.2-6.8.2s-5 0-6.8-.2c-1.5-.2-2.5-1.3-2.7-2.8-.2-1-.2-2.2-.2-3.5s0-2.5.2-3.5Z', key: 'youtube-frame' }],
  ['path', { d: 'm10 9 5 3-5 3V9Z', key: 'youtube-play' }],
])

const Facebook = createLucideIcon('Facebook', [
  ['path', { d: 'M14 8h2V5h-2.4C11 5 10 6.8 10 8.8V11H8v3h2v5h3v-5h2.4l.6-3h-3V9c0-.6.4-1 1-1Z', key: 'facebook-f' }],
])

const Instagram = createLucideIcon('Instagram', [
  ['rect', { width: '16', height: '16', x: '4', y: '4', rx: '4', key: 'instagram-frame' }],
  ['circle', { cx: '12', cy: '12', r: '3.2', key: 'instagram-lens' }],
  ['path', { d: 'M16.8 7.2h.01', key: 'instagram-dot' }],
])

export const socialLinks: SocialLink[] = [
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/@ToneSignature',
    ariaLabel: 'Visit ToneSignature on YouTube',
    Icon: Youtube,
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=61592105881945',
    ariaLabel: 'Visit ToneSignature on Facebook',
    Icon: Facebook,
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/tonesignature/',
    ariaLabel: 'Visit ToneSignature on Instagram',
    Icon: Instagram,
  },
]
